import GameStatesEnum from "@/states/GameStatesEnum";
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";
import Facade from "@/Facade";
import {calculateTimeForExplosion} from "@/managers/comunication/socket/utils";
import Config from "@/config/Config";

export default class RoundEndState extends BaseState {

  begin() {
    Signals.socketClosed.add(this.onSocketClosed, this)
    Signals.roundEnd.dispatch()
    Facade.state = 'end'
    Facade.model.roundEnd()

    Config.timeForExplosion = calculateTimeForExplosion(Facade.model.makeBetsTime)
    setTimeout(() => {
      this.end()
    }, Config.timeForExplosion * 1000)
  }

  end = () => {
    this.stateMachine.setState(GameStatesEnum.MAKE_BETS)
  }

  onSocketClosed() {
    this.stateMachine.setState(GameStatesEnum.RECONNECT_SOCKET)
  }

  cleanUp() {
    Signals.socketClosed.remove(this.onSocketClosed, this)
   }
}
